// script interface
import "../components/common_componentc/normalize/index";
import "../components/common_componentc/global_styles/index";
import "../components/interface/grid/index";
import "../components/interface/form/index";
import "../components/interface/button/index";

// script common elements
// import '../components/module/catalog_elements/index'
// import '../components/module/subscribe_section/index'
import "../components/module/modal_script/index";
import "../components/module/swiper/index";
import "../components/module/form_action/index";
import "../../source/lib/custom_mask/index";
import "../components/common_componentc/product_count/index";

// script pages
import "../components/common_componentc/header/index";
import "../components/common_componentc/footer/index";
import "../components/module/validation/index";
// import "../components/common_componentc/form_action/index";

import "../components/pages/product/index";
import "../components/pages/product/swiper";
import "../components/pages/product/product";
import "../components/pages/product/reviews";
import "../components/pages/order/form";
